<!------------------------------------------------------------------------------
  Copyright (c) 2019. Keni Williams <kenneth.williams@estuk.co.uk>

  This file CheckoutStripeHiddenComponents.vue is part of event_pass_client.dev.
  Unauthorized copying of this file, via any medium is strictly prohibited.
  Proprietary and confidential
  CheckoutStripeHiddenComponents.vue can not be copied and/or distributed
  without the express permission of Keni Williams <kenneth.williams@estuk.co.uk>
  ----------------------------------------------------------------------------->

<template>
    <div>
        <input v-if="stripe.payment_method_id !== null"
               type="hidden"
               name="stripePaymentMethodId"
               :value="stripe.payment_method_id">
        <input v-if="stripe.payment_intent_id !== null"
               type="hidden"
               name="payment_intent_id"
               :value="stripe.payment_intent_id">
    </div>
</template>

<script>
    export default {
        name: "CheckoutStripeHiddenComponents",
        props: {
            stripe: Object
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/checkout/CheckoutStripeHiddenComponents.vue